import React from 'react';
import './CarCompare.css'; 

import { EmptyState, PageTitle } from '../../../components';
import { useCompare } from '../../../utils';

import { FaGaugeSimpleHigh, FaTrashCan } from 'react-icons/fa6';
import { FaCar, FaDollarSign, FaCalendarAlt, FaWrench, FaCogs, FaGasPump, FaTachometerAlt, FaRoad, FaUsers, FaToolbox } from "react-icons/fa";

import { Link } from 'react-router-dom'; 



const ComparePage = () => {

  // Accessing comparison functionality from custom hook
  const { compare, removeFromCompare, clearCompare } = useCompare();

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Car Compare'} page={'Car Compare'} />

      <section>
        {compare.length === 0 ? (
          // If no cars are added to compare, show an empty state message
          <EmptyState 
            title="Nothing to Compare"
            message="Please add cars to compare their features."
            icon="compare"
            buttonText="Browse Cars"
            buttonLink="Car-List"
          />
        ) : (
          <>
            <div className="car-compare">

              <div className="compare-container">
                <div className="container">

                  {/* Display added cars for comparison */}
                  <div className="cars">
                    {compare.map(car => {
                      const carName = `${car.details.carMake} ${car.details.carModel}`; // Store car name in a variable

                      return (
                        <div className="car-item" key={car.id}>
                          <img src={car.image} alt={carName} />
                          <div className="content">
                            <div className="label">{car.condition}</div>
                            <Link 
                              to={{ pathname: `/Cars/${carName.replace(/\s+/g, '-')}` }} 
                              state={car}
                            >
                              <h2>{carName}</h2>
                            </Link>
                            <div className="price">${car.price}</div>
                            <button className='button' onClick={() => removeFromCompare(car)}>
                              <FaTrashCan />
                            </button>
                          </div>
                        </div>
                      );
                    })
                    }
                  </div>

                  {/* Comparison Section */}
                  <div className="cars-comparison">

                    {/* Price Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaDollarSign /></div><span>Price ($)</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>${car.price}</li>)}</ul>
                    </div>
                    
                    {/* Year Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaCalendarAlt /></div><span>Year</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.year}</li>)}</ul>
                    </div>
                    
                    {/* Condition Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaWrench /></div><span>Condition</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.condition}</li>)}</ul>
                    </div>
                    
                    {/* Car Type Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaCar /></div><span>Car Type</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.carType}</li>)}</ul>
                    </div>

                    {/* Engine Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaCogs /></div><span>Engine</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.engine}</li>)}</ul>
                    </div>

                    {/* Horsepower Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaGaugeSimpleHigh /></div><span>Horsepower</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.horsepower} HP</li>)}</ul>
                    </div>

                    {/* Top Speed Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaTachometerAlt /></div><span>Top Speed</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.topSpeed} mph</li>)}</ul>
                    </div>

                    {/* Drivetrain Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaRoad /></div><span>Drivetrain</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.drivetrain}</li>)}</ul>
                    </div>

                    {/* Transmission Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaToolbox /></div><span>Transmission</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.transmission}</li>)}</ul>
                    </div>

                    {/* Fuel Type Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaGasPump /></div><span>Fuel Type</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.fuelType}</li>)}</ul>
                    </div>

                    {/* Mileage Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaGaugeSimpleHigh /></div><span>Mileage</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.mileage} MPG</li>)}</ul>
                    </div>

                    {/* Passengers Comparison */}
                    <div className="compare-item">
                      <h5><div className='icon'><FaUsers /></div><span>Passengers</span></h5>
                      <ul>{compare.map(car => <li key={car.id}>{car.details.passengers}</li>)}</ul>
                    </div>

                  </div>

                </div>
              </div>

              {/* Clear all compared cars button */}
              <button onClick={clearCompare} className="clear-btn btn">Clear Compare List</button>

            </div>
          </>
        )}
      </section>
    </>
  );
};

export default ComparePage;
